import { AxiosResponse } from "axios";
import { IAppointment, IValidationResult } from "lobbie";
import { useCallback, useEffect, useState } from "react";
import { useAxiosGetter } from "src/hooks/useAxios";
import { handleError, isFailedRequest, notify } from "src/utils";

export const usePatientAppointments = (isGetOnLoad: boolean) => {
    const getter = useAxiosGetter();
    const [appointments, setAppointments] = useState<IAppointment[]>([]);
    const [isLoading, setLoading] = useState<boolean>(false);

    const getAppointments = useCallback(() => {
        setLoading(true);
        getter("/patient/appointments")
            .then((response: AxiosResponse | void) => {
                setLoading(false);
                const result = response && (response.data as IAppointment[] | IValidationResult);
                if (!result) {
                    response?.status &&
                        response.status > 399 &&
                        notify({
                            level: "error",
                            title: "Error getting apopintments.",
                        });
                }
                if (isFailedRequest(result as IValidationResult)) {
                    notify({
                        level: "error",
                        title: "Failed to get appointments.",
                        message: (result as IValidationResult).message || "",
                    });
                } else {
                    setAppointments(result as IAppointment[]);
                }
            })
            .catch((error) => {
                setLoading(false);
                handleError(error);
            });
    }, [getter]);

    useEffect(() => {
        if (!isGetOnLoad) return;

        getAppointments();
    }, [isGetOnLoad, getAppointments]);

    return {
        appointments,
        getAppointments,
        isLoading,
    };
};
